module.exports = __webpack_public_path__ + "img/cloud2.f9e8f87b.png";